import { URLPrefix } from 'constants/common';
import { BrandingTypes } from 'services/resources';

export const isWeeveHost = () => {
  const WEEVE_RE = new RegExp(`^${URLPrefix.WEEVE}\\.`);
  return WEEVE_RE.test(window.location.hostname);
};

export const isAvigoHost = () => {
  const AVIGO_RE = new RegExp(`^${URLPrefix.AVIGO}\\.`);
  return AVIGO_RE.test(window.location.hostname);
};

export const isThirdPartyHost = isWeeveHost() || isAvigoHost();

export const getBrandingTranslationKey = (brandingType: BrandingTypes, suffix: string) => {
  switch (brandingType) {
    case BrandingTypes.WEEVE:
    case BrandingTypes.AVIGO:
      return `${brandingType}${suffix.charAt(0).toUpperCase()}${suffix.slice(1)}`;
    default:
      return suffix;
  }
};
